/* DFF UI — product page logic, rails, reveals, lightbox, recommendations.
   Works alongside Dawn: add-to-cart goes through Dawn's <product-form>,
   so the cart drawer / notification keep working untouched. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- scroll reveals ---------------- */
  var revealObserver = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('[data-dff-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) {
      if (!el.style.getPropertyValue('--dff-delay')) {
        var idx = Array.prototype.indexOf.call(el.parentElement ? el.parentElement.children : [], el);
        el.style.setProperty('--dff-delay', Math.min(Math.max(idx, 0), 6) * 70 + 'ms');
      }
      revealObserver.observe(el);
    });
  }

  /* ---------------- rails (carousels) ---------------- */
  function initRail(rail) {
    if (!rail || rail.dataset.dffRailReady) return;
    rail.dataset.dffRailReady = '1';
    var scope = rail.closest('[data-dff-rail-scope]') || rail.parentElement;
    var thumb = scope.querySelector('.dff-rail-ctl__thumb');
    var btns = scope.querySelectorAll('.dff-rail-ctl button[data-dir]');

    function update() {
      if (!thumb) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var vis = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
      var w = Math.max(14, Math.min(100, vis * 100));
      var ratio = max > 0 ? rail.scrollLeft / max : 0;
      thumb.style.width = w + '%';
      thumb.style.transform = 'translateX(' + ratio * (100 / w * (100 - w)) + '%)';
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = rail.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 18 : 280;
        rail.scrollBy({ left: step * parseInt(b.dataset.dir, 10) * (window.innerWidth > 989 ? 2 : 1), behavior: 'smooth' });
      });
    });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    // mouse drag to scroll (desktop)
    var down = false, startX = 0, startLeft = 0, moved = false;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) { moved = true; rail.classList.add('is-dragging'); }
      if (moved) rail.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      setTimeout(function () { rail.classList.remove('is-dragging'); }, 0);
    });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  function initRails(root) {
    (root || document).querySelectorAll('[data-dff-rail]').forEach(initRail);
  }

  /* ---------------- lightbox ---------------- */
  var lightbox = null;
  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement('dialog');
      lightbox.className = 'dff-lightbox';
      lightbox.innerHTML = '<div class="dff-lightbox__inner"><img alt=""><button type="button" class="dff-lightbox__close" aria-label="Close">✕</button></div>';
      document.body.appendChild(lightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target.tagName !== 'IMG') lightbox.close();
      });
    }
    var img = lightbox.querySelector('img');
    img.src = src;
    img.alt = alt || '';
    if (typeof lightbox.showModal === 'function') lightbox.showModal();
    else window.open(src, '_blank');
  }

  /* ---------------- product page ---------------- */
  function initPDP(root) {
    if (root.dataset.dffReady) return;
    root.dataset.dffReady = '1';

    var dataEl = root.querySelector('[data-dff-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = root.querySelector('[data-dff-qty-input]');
    var atc = root.querySelector('.dff-btn--atc');
    var atcLabel = root.querySelector('[data-dff-atc-label]');
    var priceNow = root.querySelector('[data-dff-price-now]');
    var priceWas = root.querySelector('[data-dff-price-was]');
    var priceBadge = root.querySelector('[data-dff-price-badge]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-dff-option]'));
    var track = root.querySelector('[data-dff-gallery-track]');
    var sticky = root.querySelector('[data-dff-sticky]');
    var bundle = root.querySelector('[data-dff-bundle]');
    var strings = {
      add: root.dataset.addLabel || 'Add to cart',
      sold: root.dataset.soldLabel || 'Sold out :(',
      unavailable: root.dataset.unavailableLabel || 'Unavailable'
    };

    function label3d(text) {
      var esc = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      return '<span class="dff-3d" data-text="' + esc + '">' + esc + '</span>';
    }

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function markAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('.dff-pill').forEach(function (pill) {
          var input = pill.querySelector('input');
          var test = opts.slice();
          test[idx] = input.value;
          var available = variants.some(function (v) {
            if (!v.available) return false;
            for (var k = 0; k < test.length; k++) {
              if (k === idx) { if (v.options[k] !== test[k]) return false; }
              else if (k < idx && test[k] !== null && v.options[k] !== test[k]) return false;
            }
            return true;
          });
          pill.classList.toggle('is-unavailable', !available);
        });
        var chosen = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-dff-option-value]');
        if (out && chosen) out.textContent = chosen.value;
      });
    }

    function moveMediaFirst(mediaId) {
      if (!track || !mediaId) return;
      var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      if (slide !== track.firstElementChild) track.insertBefore(slide, track.firstElementChild);
      track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      buildDots();
    }

    function setBundlePrices(v) {
      if (!bundle || !v) return;
      bundle.querySelectorAll('[data-dff-bundle-price]').forEach(function (el) {
        var key = el.getAttribute('data-dff-bundle-price');
        if (key === '1') el.innerHTML = v.price;
        if (key === 'deal') el.innerHTML = v.deal_price + '<s>' + v.deal_was + '</s>';
      });
    }

    function update(fromInit) {
      var opts = selectedOptions();
      var v = fieldsets.length ? findVariant(opts) : variants[0];
      markAvailability(opts);
      if (!v) {
        if (idInput) idInput.disabled = true;
        if (atc) atc.setAttribute('disabled', 'disabled');
        if (atcLabel) atcLabel.innerHTML = label3d(strings.unavailable);
        return;
      }
      if (idInput) { idInput.value = v.id; idInput.disabled = false; }
      if (atc) {
        if (v.available) atc.removeAttribute('disabled'); else atc.setAttribute('disabled', 'disabled');
        atc.removeAttribute('aria-disabled');
      }
      if (atcLabel) atcLabel.innerHTML = label3d(v.available ? strings.add : strings.sold);
      if (priceNow) priceNow.innerHTML = v.price;
      if (priceWas) { priceWas.innerHTML = v.compare || ''; priceWas.hidden = !v.compare; }
      if (priceBadge) {
        if (v.compare_cents > v.price_cents) {
          priceBadge.textContent = 'SAVE ' + Math.round((1 - v.price_cents / v.compare_cents) * 100) + '%';
          priceBadge.hidden = false;
        } else priceBadge.hidden = true;
      }
      setBundlePrices(v);
      if (sticky) {
        var sp = sticky.querySelector('[data-dff-sticky-price]');
        if (sp) sp.innerHTML = v.price;
        var sb = sticky.querySelector('[data-dff-sticky-add]');
        if (sb) { if (v.available) sb.removeAttribute('disabled'); else sb.setAttribute('disabled', 'disabled'); sb.innerHTML = label3d(v.available ? 'Add' : 'Sold out'); }
      }
      if (!fromInit) {
        if (v.media) moveMediaFirst(v.media);
        if (window.history && window.history.replaceState && fieldsets.length) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () { update(false); });
    });

    /* quantity + bundle */
    function setQty(n) {
      if (!qtyInput) return;
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      qtyInput.value = n;
      if (bundle) {
        bundle.querySelectorAll('.dff-bundle__opt').forEach(function (opt) {
          var input = opt.querySelector('input');
          var match = parseInt(input.value, 10) === n;
          input.checked = match;
          opt.classList.toggle('is-active', match);
        });
      }
    }
    root.querySelectorAll('[data-dff-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.dffQty, 10));
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
    if (bundle) {
      bundle.addEventListener('change', function (e) {
        if (e.target && e.target.name && e.target.type === 'radio') setQty(e.target.value);
      });
    }

    /* ATC press bounce */
    if (atc) {
      atc.addEventListener('click', function () {
        if (atc.hasAttribute('disabled')) return;
        atc.classList.remove('is-bouncing');
        void atc.offsetWidth;
        atc.classList.add('is-bouncing');
      });
    }

    /* gallery: dots + zoom */
    var dotsWrap = root.querySelector('[data-dff-gallery-dots]');
    function buildDots() {
      if (!dotsWrap || !track) return;
      var slides = track.children;
      dotsWrap.innerHTML = '';
      if (slides.length < 2) return;
      Array.prototype.forEach.call(slides, function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'dff-gallery__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Image ' + (i + 1));
        d.addEventListener('click', function () { track.scrollTo({ left: s.offsetLeft - 20, behavior: 'smooth' }); });
        dotsWrap.appendChild(d);
      });
    }
    function syncDots() {
      if (!dotsWrap || !track) return;
      var slides = track.children, best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(slides[i].offsetLeft - 20 - track.scrollLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === best); });
    }
    if (track) {
      buildDots();
      track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
      track.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-dff-zoom]');
        if (!btn) return;
        var img = btn.querySelector('img');
        openLightbox(btn.getAttribute('data-dff-zoom'), img ? img.alt : '');
      });
    }

    /* sticky add bar */
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(atc);
      var sbtn = sticky.querySelector('[data-dff-sticky-add]');
      if (sbtn) {
        sbtn.addEventListener('click', function () {
          if (!form || atc.hasAttribute('disabled')) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(atc);
          else atc.click();
        });
      }
    }

    update(true);
  }

  /* ---------------- product recommendations ---------------- */
  function initRecos(el) {
    if (el.dataset.dffReady) return;
    el.dataset.dffReady = '1';
    var load = function () {
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var tmp = document.createElement('div');
          tmp.innerHTML = text;
          var fresh = tmp.querySelector('[data-dff-recos]');
          if (fresh && fresh.querySelector('.dff-card')) {
            el.innerHTML = fresh.innerHTML;
            initRails(el);
            initReveals(el);
          }
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(el);
    } else load();
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-dff-pdp]').forEach(initPDP);
    root.querySelectorAll('[data-dff-recos][data-url]').forEach(initRecos);
    initRails(root);
    initReveals(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
